import { render } from "./SportLovComponent.vue?vue&type=template&id=262c5c14"
import script from "./SportLovComponent.vue?vue&type=script&lang=js"
export * from "./SportLovComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__